import React, { Component } from 'react';
import { Route } from 'react-router';
import { Estado } from './components/Estado';

import './custom.css'

export default class App extends Component {
  static displayName = App.name;

  render () {
      return (
              <Route path='/Validacion' component={Estado} />
    );
  }
}
